// Referee assigner details. Their own card is their whole interface: the
// organization's tournaments and its referees. The profile form is the
// referee's, since the fields are the same

import UserCardTemplate from './UserCardTemplate';
import PropItem from './PropItem';
import PropItemsBlock from './PropItemsBlock';
import RefereeCardEdit from './RefereeCardEdit';
import TournamentsList from './TournamentsList';
import RefereesList from './RefereesList';
import { useFirebase } from './FirebaseContextProvider';
import placeholderPerson from '../assets/images/placeholder-person.png';

export default function RefereeAssignerCard({ assigner }) {
  const { user, userIsAdmin } = useFirebase();
  const { id, name, phone, email } = assigner;

  const isTheUser = user?.id === id;

  return (
    <UserCardTemplate
      header='Referee Assigner'
      className='referee-assigner-card'
      backBtn={!isTheUser}
      isTheUser={isTheUser}
      imgPath={assigner.imgPath}
      imgThumbPath={assigner.imgThumbPath}
      imgTitle={name}
      name={name}
      placeholder={placeholderPerson}
      details={
        <PropItemsBlock>
          <PropItem prop='Phone' value={phone} />
          <PropItem prop='E-mail' value={email} />
        </PropItemsBlock>
      }
      editForm={
        (userIsAdmin || isTheUser) && <RefereeCardEdit referee={assigner} />
      }
      tabs={
        isTheUser
          ? [
              {
                title: 'Tournaments',
                hash: '#tournaments',
                component: <TournamentsList />,
              },
              {
                title: 'Referees',
                hash: '#referees',
                component: <RefereesList />,
              },
            ]
          : []
      }
    />
  );
}
